module.exports = __webpack_public_path__ + "6b7ef9135f86fe9115a2344c61984fca.png";